import * as React from 'react';
import PropTypes from 'prop-types';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';
import useLocales from '../../../hooks/useLocales';
import { blockHRStaff } from '../../../redux/slices/hrStaffSlice';

HRStaffBlockModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  passedData: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default function HRStaffBlockModal({ open, handleClose, passedData: id }) {
  const dispatch = useDispatch();
  const { translate } = useLocales();
  const { enqueueSnackbar } = useSnackbar();

  const [reason, setReason] = React.useState('');

  const handleBlock = () => {
    dispatch(blockHRStaff({
      device: window.navigator.userAgent,
      id,
      blockReason: reason.trim(),
    })).then((res) => {
      if (!res.error) {
        enqueueSnackbar(translate('blockStaffSuccess'), { delay: 2000 });
      }
      handleClose();
    });
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm" aria-labelledby="staff-block-dialog">
      <DialogTitle id="staff-block-dialog">
        {translate('blockWorker')}
      </DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          {translate('blockWarning')}
        </Alert>
        <DialogContentText sx={{ mb: 2 }}>
          {translate('blockReasonDescription')}
        </DialogContentText>
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={3}
          required
          label={translate('blockReason')}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={handleClose}>
          {translate('cancel')}
        </Button>
        <Button variant="contained" color="error" onClick={handleBlock} disabled={!reason.trim()}>
          {translate('block')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
